"use client";
import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const anchorLinkInputs = [
  {
    name: "anchorId",
    type: "string",
    required: true,
    defaultValue: "anchor-id",
  },
] as const satisfies Inputs;

export type AnchorLinkProps = BuilderComponentProps<typeof anchorLinkInputs>;

export const AnchorLinkComponent: RegisteredComponent = {
  name: "AnchorLink",
  component: withValidation(
    anchorLinkInputs,
    dynamic(() => import("./AnchorLink").then((mod) => mod.AnchorLink)),
    "AnchorLink"
  ),
  inputs: anchorLinkInputs,
};
